import type { AspectRatio } from '@lumen5/luminary';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import {
    CLIP_CREATOR_DEFAULT_ASPECT_RATIO,
    CLIP_CREATOR_DEFAULT_CAPTION_STYLE,
    CLIP_CREATOR_DEFAULT_WAVEFORM_STYLE,
} from 'js/src/data/clip-creator/clip-creator-consts';
import type { RootState } from 'js/src/libs/RootState';

type InitialState = {
    aspectRatio: AspectRatio;
    captionStyle: string;
    waveformStyle: string;
};

const initialState: InitialState = {
    aspectRatio: CLIP_CREATOR_DEFAULT_ASPECT_RATIO,
    captionStyle: CLIP_CREATOR_DEFAULT_CAPTION_STYLE,
    waveformStyle: CLIP_CREATOR_DEFAULT_WAVEFORM_STYLE,
};

export const planner = createSlice({
    name: 'planner',
    initialState,
    reducers: {
        saveAspectRatioSetting: (state, action: PayloadAction<AspectRatio>) => {
            state.aspectRatio = action.payload;
        },
        saveCaptionStyleSetting: (state, action: PayloadAction<string>) => {
            state.captionStyle = action.payload;
        },
        saveWaveformStyleSetting: (state, action: PayloadAction<string>) => {
            state.waveformStyle = action.payload;
        },
    },
    selectors: {
        getAspectRatioSetting: (state) => state.aspectRatio,
        getCaptionStyleSetting: (state) => state.captionStyle,
        getWaveformStyleSetting: (state) => state.waveformStyle,
    },
});

export const { saveAspectRatioSetting, saveCaptionStyleSetting, saveWaveformStyleSetting } =
    planner.actions;
export const { getAspectRatioSetting, getCaptionStyleSetting, getWaveformStyleSetting } =
    planner.getSelectors((state: RootState) => state.clip_creator.planner);
